export default "/images/vendor/flag-icons/flags/4x3/kp.svg?1bcf41f7359a335ca2d809e7a77659e3";